<template>
  <el-dialog
    title="编辑商机"
    :visible.sync="dialogVisible"
    width="600px"
    @close="resetForm"
    :close-on-click-modal="false"
  >
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="auto">
      <!-- 客户名称 -->
      <el-form-item label="客户名称" prop="customer_name">
        <el-input
          v-model.trim="dataForm.customer_name"
          placeholder="请输入客户名称"
          maxlength="50"
          show-word-limit
        />
      </el-form-item>

      <!-- 期望起租时间 -->
      <el-form-item label="期望起租时间" prop="expected_start_time">
        <el-date-picker
          v-model="dataForm.expected_start_time"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="请选择期望起租时间"
          style="width: 100%"
        />
      </el-form-item>

      <!-- 需求GPU型号 -->
      <el-form-item label="需求GPU型号" prop="gpu_model">
        <el-input
          v-model.trim="dataForm.gpu_model"
          placeholder="请输入GPU型号，如：H200"
          maxlength="30"
        />
      </el-form-item>

      <!-- 需求台数 -->
      <el-form-item label="需求台数" prop="quantity">
        <el-input-number
          v-model="dataForm.quantity"
          :min="1"
          :max="9999"
          placeholder="请输入需求台数"
          style="width: 100%"
        />
      </el-form-item>

      <!-- 具体需求 -->
      <el-form-item label="具体需求" prop="details">
        <el-input
          v-model="dataForm.details"
          type="textarea"
          :rows="3"
          placeholder="请输入具体需求"
          maxlength="200"
          show-word-limit
        />
      </el-form-item>

      <!-- 期望价格 -->
      <el-form-item label="期望价格" prop="expected_price">
        <el-input-number
          v-model="dataForm.expected_price"
          :precision="2"
          :step="0.01"
          :min="0"
          :max="99999999.99"
          placeholder="请输入期望价格"
          style="width: 100%"
        />
      </el-form-item>

      <!-- 合同类型 -->
      <el-form-item label="合同类型" prop="contract_type">
        <el-select
          v-model="dataForm.contract_type"
          placeholder="请选择合同类型"
          style="width: 100%"
        >
          <el-option label="开口合同" :value="0"></el-option>
          <el-option label="闭口合同" :value="1"></el-option>
          <el-option label="售前测试" :value="2"></el-option>
        </el-select>
      </el-form-item>

      <!-- 商机可信性 -->
      <el-form-item label="商机可信性" prop="reliability">
        <el-select
          v-model="dataForm.reliability"
          placeholder="请选择可信性"
          style="width: 100%"
        >
          <el-option label="高" :value="1"></el-option>
          <el-option label="中" :value="2"></el-option>
          <el-option label="低" :value="3"></el-option>
        </el-select>
      </el-form-item>

      <!-- 备注 -->
      <el-form-item label="备注信息" prop="remark">
        <el-input
          type="textarea"
          :rows="3"
          v-model="dataForm.remark"
          placeholder="请输入备注信息"
          maxlength="200"
          show-word-limit
        />
      </el-form-item>
    </el-form>

    <!-- 按钮 -->
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="submitForm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'EditBusinessOpportunity',
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      editId: null, // 存储商机ID

      // 表单数据
      dataForm: {
        customer_name: null,           // string，必填
        expected_start_time: null,     // datetime string，必填
        gpu_model: null,               // string，必填
        quantity: null,                // integer，可选
        details: null,                 // string，可选
        expected_price: null,          // number，可选
        contract_type: null,           // integer (0,1,2)，必填
        reliability: null,             // integer (1,2,3)，可选
        remark: null                   // string，可选
      },

      // 校验规则
      dataRule: {
        customer_name: [
          { required: true, message: '客户名称不能为空', trigger: 'blur' },
          { min: 1, max: 50, message: '长度在 1 到 50 个字符之间', trigger: 'blur' }
        ],
        expected_start_time: [
          { required: true, message: '期望起租时间不能为空', trigger: 'change' }
        ],
        gpu_model: [
          { required: true, message: '需求GPU型号不能为空', trigger: 'blur' },
          { max: 30, message: '最多30个字符', trigger: 'blur' }
        ],
        contract_type: [
          { required: true, message: '请选择合同类型', trigger: 'change' }
        ]
      }
    };
  },
  methods: {
    // 打开弹窗，传入商机ID
    openDialog(opportunityId) {
      if (!opportunityId || !opportunityId.id) {
        this.$message.error('缺少商机ID');
        return;
      }

      this.editId = opportunityId.id;
      this.dialogVisible = true;

      this.$nextTick(() => {
        this.$refs.dataForm.clearValidate();
      });

      // 加载商机详情
      this.loadOpportunityDetail();
    },

    // 加载商机详情
    loadOpportunityDetail() {
      this.$axios
        .get(`/api-30216/api/opportunities/${this.editId}`)
        .then(res => {
          const data = res.data || {};
          const opportunity = data.data || data; // 兼容不同返回格式

          if (!opportunity) {
            this.$message.error('未获取到商机信息');
            this.dialogVisible = false;
            return;
          }

          // 填充表单数据
          this.dataForm = {
            customer_name: opportunity.customer_name || '',
            expected_start_time: opportunity.expected_start_time || null,
            gpu_model: opportunity.gpu_model || '',
            quantity: opportunity.quantity || null,
            details: opportunity.details || '',
            expected_price: opportunity.expected_price || null,
            contract_type: opportunity.contract_type,
            reliability: opportunity.reliability || null,
            remark: opportunity.remark || ''
          };

          console.log('✅ 已加载商机详情:', this.dataForm);
        })
        .catch(err => {
          this.$message.error('加载商机详情失败');
          console.error('加载详情错误：', err);
          this.dialogVisible = false;
        });
    },

    // 重置表单
    resetForm() {
      if (this.$refs.dataForm) {
        this.$refs.dataForm.resetFields();
      }
      // 清空数据
      this.dataForm = this.$options.data().dataForm;
      this.editId = null;
    },

    // 提交表单
    submitForm() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) {
          return;
        }

        // 构造提交数据（过滤掉 null 值，但保留 0）
        const postData = {};
        Object.keys(this.dataForm).forEach(key => {
          const value = this.dataForm[key];
          if (value !== null && value !== '') {
            postData[key] = value;
          }
        });

        this.submitLoading = true;
        this.$axios
          .put(`/api-30216/api/opportunities/${this.editId}`, postData)
          .then(res => {
            const data = res || {};
            if (data.code === 200 || data.success || data.status === 'success') {
              this.$message.success(data.message || '更新商机成功');
              this.dialogVisible = false;
              this.$emit('success'); // 通知父组件刷新列表
            } else {
              this.$message.error(data.message || '更新失败，请检查数据');
            }
          })
          .catch(err => {
            let msg = '更新商机失败';
            if (err.response && err.response.data && err.response.data.message) {
              msg = err.response.data.message;
            } else if (err.message) {
              msg = err.message;
            }
            this.$message.error(msg);
            console.error('提交错误：', err);
          })
          .finally(() => {
            this.submitLoading = false;
          });
      });
    }
  }
};
</script>

<style scoped>
.el-form {
  padding: 10px;
}

.el-input,
.el-select,
.el-date-picker {
  width: 100%;
}
</style>